import React from 'react';
import PropTypes from 'prop-types';
import pluralize from 'pluralize';
import Notification from '~/components/Notification';
import {isArt, isUpload} from '~/data/accessors/icon';
import {Button, Stack} from '@customink/pigment-react';
import {useNavigate} from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';
import {getHighestColorSleeveIcon} from '~/selectors/CanvasSelectors';
import {selectIcons} from '~/actions/SelectionActions';

function getSorryMessage(inkColors) {
  return (
    <p className="ndx-cta1">
      We can print a maximum of {inkColors} on a sleeve. Adjust your design so
      it is {inkColors} or less before continuing.
    </p>
  );
}

/** @param {PropTypes.InferProps<typeof propTypes>} props - Component properties. */
export default function TooManySleeveColors({
  dismiss,
  notification: {colorLimit},
  ...props
}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const sleeveIcon = useSelector(getHighestColorSleeveIcon);

  const editColors = () => {
    const {id, viewId, type} = sleeveIcon;
    if (isArt(type)) {
      navigate('/artTools');
    } else if (isUpload(type)) {
      navigate('/uploadTools');
    }
    dispatch(selectIcons({iconIds: [id], viewId}));
  };

  const inkColors = `${colorLimit} ink ${pluralize('color', colorLimit)}`;
  const dismissNotification = () => {
    navigate('/');
    dismiss();
  };
  return (
    <Notification
      {...props}
      dismiss={dismissNotification}
      title="Too much color">
      {getSorryMessage(inkColors)}
      <Stack className="notification-stack">
        <Button
          size="large"
          variant="secondary"
          className="notification-cta"
          onClick={() => {
            editColors();
            dismiss();
          }}>
          Edit Colors
        </Button>
      </Stack>
    </Notification>
  );
}

const propTypes = {
  dismiss: PropTypes.func,
  notification: PropTypes.shape({
    colorLimit: PropTypes.number
  })
};

TooManySleeveColors.propTypes = propTypes;

TooManySleeveColors.displayName = 'TooManySleeveColors';
